import React from 'react'
import gql from 'graphql-tag'

import Query from 'components/shared/Query'
import Heading from 'components/shared/Heading'

import PhotographerBrief from './PhotographerBrief'

const PHOTOGRAPHER_MESSAGES_QUERY = gql`
  query PhotoOrderPreference {
    viewer {
      id
      broker {
        id
        instructionsForPhotographer
        customer {
          instructionsForPhotographer
          region {
            instructionsForPhotographer
          }
          chain {
            instructionsForPhotographer
          }
        }
      }
    }
  }
`

const GeneralPhotographerInstructions = () => {
  return (
    <>
      <Heading level={2}>Fast beskjed til fotograf</Heading>
      <Query
        inlineError
        query={PHOTOGRAPHER_MESSAGES_QUERY}
      >
        {({getData, loading, data}) => {
          if (!loading) {
            const currentBrief = getData('viewer.broker.instructionsForPhotographer')

            const inheritedPhotographerBrief = [
              getData('viewer.broker.customer.chain.instructionsForPhotographer'),
              getData('viewer.broker.customer.region.instructionsForPhotographer'),
              getData('viewer.broker.customer.instructionsForPhotographer'),
            ].filter(o => o).join('. ').replace('..', '.')

            return (
              <>
                {inheritedPhotographerBrief && (
                  <>
                    <Heading level={3}>Overordnet</Heading>
                    <p>{inheritedPhotographerBrief}</p>
                  </>
                )}
                <PhotographerBrief currentBrief={currentBrief} />
              </>
            )
          }

          return null
        }}
      </Query>
    </>
  )
}

export default GeneralPhotographerInstructions
